import React, { Component } from "react";
import { decode as base64_decode } from "base-64";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { Typography, Image } from "antd";
import Cookies from "universal-cookie";
import VehicleStore from "../store/VehicleStore";

const { Title } = Typography;
class SecureTrackMonitor extends Component {
  constructor(props) {
    super(props);

    this.cookies = new Cookies();
    this.vehicleStore = new VehicleStore()
  }
  async componentDidMount() {
    console.log("SecureTrackMonitor mounted successfully");
    await this.vehicleStore.loadData({
      companyId: this.props.getUserData().userCompanyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      usercompanyId: this.props.getUserData().userCompanyId,
      offset: 0,
      limit: 50,
      totalCounts: 1
    });

    this.setState({ loadData: 1 });
  }




  render() {
    const isAdmin = JSON.parse(base64_decode(this.cookies.get("data"))).isadmin;
    return (
      <div className="monitorapp-container">
        <div className="login-overlay">
          <div className="container mt-4" style={{ textAlign: 'right' }}>
            <Image
              src={require('../assets/images/swd-dashboard-st.png')}
              alt="SecureTrackX"
              preview={false}
              className="mainLogo"
            />
          </div>

          {/* Login Circles */}
          <div className="login-section-2">
            {/* {!(isAdmin === 0 || isAdmin === 1) && (
              <div className="circle-1 login-circle">
                <div className="bggreen gap-2">
                  <Image
                    src={require('../assets/images/st-monitor-renew.png')}
                    alt="SecurePath"
                    preview={false}
                    className="circle-logo"
                    height={"38px"}

                  />
                  <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                    RENEW
                  </Title>
                  <span style={{ color: '#FFF', padding: '0px 8px', fontSize: '0.75rem', }}>
                    10
                  </span>
                </div>
              </div>
            )} */}


            <div className="circle-2 login-circle-2 large-2"
              onClick={() => this.props.navigate("/SecureTrackLaunchingDashboard")}
              style={{ cursor: "pointer" }}
            >
              <div className="bgblack">
                <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                  MONITOR
                </Title>
              </div>
            </div>

            {/* SecureTrack Basic Circle */}
            {/* {!(isAdmin === 0 || isAdmin === 1) && (
              <div className="circle-3 login-circle">
                <div className="bgred text-center">
                  <div className="new-img ">
                    <Image
                      src={require('../assets/images/st-monitor-new.png')}
                      alt="SecurePath"
                      preview={false}
                      height={"100px"}
                    />
                    <Title level={5} className="white-text mt-4" style={{ marginBottom: '-15px', color: 'white', position: 'absolute', marginLeft: '45px' }}>
                      NEW
                    </Title>
                  </div>
                </div>
              </div>
            )} */}

            <div className="vehicle-counts-row">
              {(isAdmin === 0 || isAdmin === 1) && (
                <div className="vehicle-counts-circle" onClick={() => {
                  this.props.navigate("/vehiclelist/0")
                }}>
                  <div className="vehicle-count-content total-circle">
                    <Title level={5} className="white-text">
                      Total
                    </Title>

                    <span className="vehicle-count-number">
                      {this.vehicleStore.total}
                    </span>
                  </div>
                </div>
              )}


              {(isAdmin === 0 || isAdmin === 1) && (
                <div className="vehicle-counts-circle" onClick={() => {
                  this.props.navigate("/vehiclelist/4")
                }}>
                  <div className="vehicle-count-content expiring-circle">
                    <Title level={5} className="white-text">
                      Expiring Soon
                    </Title>

                    <span className="vehicle-count-number">
                      {this.vehicleStore.expiringSoonCount}
                    </span>
                  </div>
                </div>
              )}


              {(isAdmin === 0 || isAdmin === 1) && (
                <div className="vehicle-counts-circle" onClick={() => {
                  this.props.navigate("/vehiclelist/3")
                }}>
                  <div className="vehicle-count-content expired-circle">
                    <Title level={5} className="white-text">
                      Expired
                    </Title>

                    <span className="vehicle-count-number">
                      {this.vehicleStore.expiredCount}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
SecureTrackMonitor.contextType = StoreContext;
export default observer(withRouter(SecureTrackMonitor));
